import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getLanguagesListRequest: null,
  getLanguagesListSuccess: ["payload"], // payload: { data }
  getLanguagesListFailure: ["payload"], // payload: { errors }

  settingsSaveResultReset: null,
  settingsErrorsReset: null,

  getNotificationsListRequest: null,
  getNotificationsListSuccess: ["payload"], // payload: { data }
  getNotificationsListFailure: ["payload"], // payload: { errors }

  changeNotificationsListRequest: ["payload"], // payload: { data },
  changeNotificationsListSuccess: ["payload"], // payload: { data }
  changeNotificationsListFailure: ["payload"], // payload: { errors }

  getUserCountryRequest: null,
  getUserCountrySuccess: ["payload"],
  getUserCountryFailure: ["payload"], // payload: { errors }

  navToStripeRequest: ["payload"],
  navToStripeSuccess: ["payload"],
  navToStripeFailure: ["payload"],

  getUsersManagementRolesRequest: null,
  getUsersManagementRolesSuccess: ["roles"],
  getUsersManagementRolesFailure: null,

  getUsersManagementRequest: ["payload"],
  getUsersManagementSuccess: ["payload"], // payload: { users }
  getUsersManagementFailure: null,

  createInviteUserRequest: ["payload"], // payload: { data }
  createInviteUserSuccess: ["payload"], // payload: { data }
  createInviteUserFailure: null,

  updateInviteUserRequest: ["payload"], // payload: { data }
  updateInviteUserSuccess: ["payload"], // payload: { data }
  updateInviteUserFailure: null,

  resendInviteUserRequest: ["payload"], // payload: { userId }
  resendInviteUserSuccess: ["payload"], // payload: { data }
  resendInviteUserFailure: null,

  removeUserRequest: ["payload"], // payload: { userId }
  removeUserSuccess: ["payload"], // payload: { data }
  removeUserFailure: null,

  getInviteUserInfoRequest: ["payload"], // payload: { inviteId }
  getInviteUserInfoSuccess: ["payload"], // payload: { data }
  getInviteUserInfoFailure: null,
  clearInviteUserInfo: null,

  rejectInviteUserRequest: ["payload"], // payload: { inviteId }
  rejectInviteUserSuccess: ["payload"], // payload: { data }
  rejectInviteUserFailure: null,

  acceptInviteUserRequest: ["payload"], // payload: { inviteId }
  acceptInviteUserSuccess: ["payload"], // payload: { data }
  acceptInviteUserFailure: null,

  logoutInviteUserRequest: ["payload"], // payload: { inviteId }
  logoutInviteUserSuccess: ["payload"], // payload: { data }
  logoutInviteUserFailure: null,

  setLastLanguagePlanPage: ["payload"],

  logout: null
})

export const SettingTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  languages: [],
  notifications: {},

  subscribe: null,
  userCountry: null,

  saveResult: false,
  saveFetching: false,

  fetching: false,
  errors: false,

  lastLanguage: "",

  rolesFetching: false,
  roles: [],

  users: [],

  inviteInfoFetching: false,
  inviteInfo: null
})

/* ------------- Functions for reducer cases ------------- */

// GET LANGUAGES LIST

const getLanguagesListRequest = (state) => state.merge({ fetching: true })

const getLanguagesListSuccess = (state, { payload: data }) =>
  state.merge({ fetching: false, languages: data })

const getLanguagesListFailure = (state, { payload: { errors } }) =>
  state.merge({ fetching: false, errors })

// RESET RESULT AND ERRORS
export const settingsSaveResultReset = (state) => {
  return state.merge({
    fetching: false,
    saveFetching: false,
    saveResult: null
  })
}
export const settingsErrorsReset = (state) => {
  return state.merge({ fetching: false, saveFetching: false, errors: false })
}

// GET NOTIFICATIONS

export const getNotificationsListRequest = (state) => state.merge({ fetching: true })

export const getNotificationsListSuccess = (state, { payload: data }) =>
  state.merge({ fetching: false, saveFetching: false, notifications: data })

export const getNotificationsListFailure = (state, { payload: { errors } }) =>
  state.merge({ fetching: false, saveFetching: false, errors })

// CHANGE NOTIFICATIONS LIST

export const changeNotificationsListRequest = (state) => state.merge({ saveFetching: true })

export const changeNotificationsListSuccess = (state, { payload: data }) => {
  return state.merge({
    notifications: data,
    saveFetching: false,
    saveResult: true
  })
}

export const changeNotificationsListFailure = (state, { payload: { errors } }) =>
  state.merge({ saveFetching: false, errors })

export const getUserCountryRequest = (state) => state.merge({ fetching: true })
export const getUserCountrySuccess = (state, { payload }) =>
  state.merge({ fetching: false, userCountry: { ...payload } })
export const getUserCountryFailure = (state, { payload: { errors } }) =>
  state.merge({ fetching: false, errors })

const navToStripeRequest = (state) => state.merge({ fetching: true })
const navToStripeSuccess = (state) => state.merge({ fetching: false })
const navToStripeFailure = (state) => state.merge({ fetching: false })

export const getUsersManagementRolesRequest = (state) => state.merge({ rolesFetching: true })
export const getUsersManagementRolesSuccess = (state, { roles }) =>
  state.merge({ rolesFetching: false, roles })
export const getUsersManagementRolesFailure = (state) => state.merge({ rolesFetching: false })

export const getUsersManagementRequest = (state) => state.merge({ fetching: true })
export const getUsersManagementSuccess = (state, { payload: users }) =>
  state.merge({ fetching: false, users })
export const getUsersManagementFailure = (state) => state.merge({ fetching: false })

export const createInviteUserRequest = (state) => state.merge({ saveFetching: true })
export const createInviteUserSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "invite_create" })
export const createInviteUserFailure = (state) => state.merge({ saveFetching: false })

export const updateInviteUserRequest = (state) => state.merge({ saveFetching: true })
export const updateInviteUserSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "invite_update" })
export const updateInviteUserFailure = (state) => state.merge({ saveFetching: false })

export const resendInviteUserRequest = (state) => state.merge({ saveFetching: true })
export const resendInviteUserSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "invite_resend" })
export const resendInviteUserFailure = (state) => state.merge({ saveFetching: false })

export const removeUserRequest = (state) => state.merge({ saveFetching: true })
export const removeUserSuccess = (state, { payload: user }) => {
  const newUsers = [...state.users].filter((el) => el.id !== (user?.id || user))
  return state.merge({
    saveFetching: false,
    saveResult: "removed",
    users: newUsers
  })
}
export const removeUserFailure = (state) => state.merge({ saveFetching: false })

export const getInviteUserInfoRequest = (state) => state.merge({ inviteInfoFetching: true })
export const getInviteUserInfoSuccess = (state, { payload: inviteInfo }) =>
  state.merge({ inviteInfoFetching: false, inviteInfo })
export const getInviteUserInfoFailure = (state) => state.merge({ inviteInfoFetching: false })
export const clearInviteUserInfo = (state) => state.merge({ inviteInfo: null })

export const rejectInviteUserRequest = (state) => state.merge({ saveFetching: true })
export const rejectInviteUserSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "invite_reject", inviteInfo: null })
export const rejectInviteUserFailure = (state) => state.merge({ saveFetching: false })

export const acceptInviteUserRequest = (state) => state.merge({ saveFetching: true })
export const acceptInviteUserSuccess = (state) =>
  state.merge({ saveFetching: false, saveResult: "invite_accept", inviteInfo: null })
export const acceptInviteUserFailure = (state) => state.merge({ saveFetching: false })

export const logoutInviteUserRequest = (state) => state
export const logoutInviteUserSuccess = (state) => state
export const logoutInviteUserFailure = (state) => state

const setLastLanguagePlanPage = (state, { payload: data }) => state.merge({ lastLanguage: data })

const logout = (state) => INITIAL_STATE

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_LANGUAGES_LIST_REQUEST]: getLanguagesListRequest,
  [Types.GET_LANGUAGES_LIST_SUCCESS]: getLanguagesListSuccess,
  [Types.GET_LANGUAGES_LIST_FAILURE]: getLanguagesListFailure,

  [Types.SETTINGS_SAVE_RESULT_RESET]: settingsSaveResultReset,
  [Types.SETTINGS_ERRORS_RESET]: settingsErrorsReset,

  [Types.GET_NOTIFICATIONS_LIST_REQUEST]: getNotificationsListRequest,
  [Types.GET_NOTIFICATIONS_LIST_SUCCESS]: getNotificationsListSuccess,
  [Types.GET_NOTIFICATIONS_LIST_FAILURE]: getNotificationsListFailure,

  [Types.CHANGE_NOTIFICATIONS_LIST_REQUEST]: changeNotificationsListRequest,
  [Types.CHANGE_NOTIFICATIONS_LIST_SUCCESS]: changeNotificationsListSuccess,
  [Types.CHANGE_NOTIFICATIONS_LIST_FAILURE]: changeNotificationsListFailure,

  [Types.GET_USER_COUNTRY_REQUEST]: getUserCountryRequest,
  [Types.GET_USER_COUNTRY_SUCCESS]: getUserCountrySuccess,
  [Types.GET_USER_COUNTRY_FAILURE]: getUserCountryFailure,

  [Types.GET_USERS_MANAGEMENT_ROLES_REQUEST]: getUsersManagementRolesRequest,
  [Types.GET_USERS_MANAGEMENT_ROLES_SUCCESS]: getUsersManagementRolesSuccess,
  [Types.GET_USERS_MANAGEMENT_ROLES_FAILURE]: getUsersManagementRolesFailure,

  [Types.GET_USERS_MANAGEMENT_REQUEST]: getUsersManagementRequest,
  [Types.GET_USERS_MANAGEMENT_SUCCESS]: getUsersManagementSuccess,
  [Types.GET_USERS_MANAGEMENT_FAILURE]: getUsersManagementFailure,

  [Types.CREATE_INVITE_USER_REQUEST]: createInviteUserRequest,
  [Types.CREATE_INVITE_USER_SUCCESS]: createInviteUserSuccess,
  [Types.CREATE_INVITE_USER_FAILURE]: createInviteUserFailure,

  [Types.UPDATE_INVITE_USER_REQUEST]: updateInviteUserRequest,
  [Types.UPDATE_INVITE_USER_SUCCESS]: updateInviteUserSuccess,
  [Types.UPDATE_INVITE_USER_FAILURE]: updateInviteUserFailure,

  [Types.RESEND_INVITE_USER_REQUEST]: resendInviteUserRequest,
  [Types.RESEND_INVITE_USER_SUCCESS]: resendInviteUserSuccess,
  [Types.RESEND_INVITE_USER_FAILURE]: resendInviteUserFailure,

  [Types.REMOVE_USER_REQUEST]: removeUserRequest,
  [Types.REMOVE_USER_SUCCESS]: removeUserSuccess,
  [Types.REMOVE_USER_FAILURE]: removeUserFailure,

  [Types.GET_INVITE_USER_INFO_REQUEST]: getInviteUserInfoRequest,
  [Types.GET_INVITE_USER_INFO_SUCCESS]: getInviteUserInfoSuccess,
  [Types.GET_INVITE_USER_INFO_FAILURE]: getInviteUserInfoFailure,

  [Types.CLEAR_INVITE_USER_INFO]: clearInviteUserInfo,

  [Types.REJECT_INVITE_USER_REQUEST]: rejectInviteUserRequest,
  [Types.REJECT_INVITE_USER_SUCCESS]: rejectInviteUserSuccess,
  [Types.REJECT_INVITE_USER_FAILURE]: rejectInviteUserFailure,

  [Types.ACCEPT_INVITE_USER_REQUEST]: acceptInviteUserRequest,
  [Types.ACCEPT_INVITE_USER_SUCCESS]: acceptInviteUserSuccess,
  [Types.ACCEPT_INVITE_USER_FAILURE]: acceptInviteUserFailure,

  [Types.LOGOUT_INVITE_USER_REQUEST]: logoutInviteUserRequest,
  [Types.LOGOUT_INVITE_USER_SUCCESS]: logoutInviteUserSuccess,
  [Types.LOGOUT_INVITE_USER_FAILURE]: logoutInviteUserFailure,

  [Types.NAV_TO_STRIPE_REQUEST]: navToStripeRequest,
  [Types.NAV_TO_STRIPE_SUCCESS]: navToStripeSuccess,
  [Types.NAV_TO_STRIPE_FAILURE]: navToStripeFailure,

  [Types.SET_LAST_LANGUAGE_PLAN_PAGE]: setLastLanguagePlanPage,

  [Types.LOGOUT]: logout
})
